import { Checkbox } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import AGGridHeaderCheckboxSimple from './AGGridHeaderCheckboxSimple';

export function AGGridCheckboxColDefaults(setData, field, headerName, max = 50) {
  return {
    field,
    headerName,
    valueGetter: (params) => params.data[field],
    cellRenderer: (params) => <Checkbox checked={params.data[field] ?? false}
      onChange={(e) => {
        setData(data => {
          if (data.filter(d => d[field]).length >= max && e.target.checked)
          {
            enqueueSnackbar(`Maxium allowed amount: ${max}`, { variant: "error" });
            return data;
          }
          const newData = { ...params.node.data };
          newData[field] = e.target.checked;
          params.node.setData(newData);
          const dataItem = data.find(di => di.id === params.node.data.id);
          if (!dataItem) return data;
          dataItem[field] = e.target.checked;
          return data;
        })
      }} />,
    headerComponent: (params) => AGGridHeaderCheckboxSimple(params, (resParams, checked) => {
      const updateRows = [];
      resParams.api.forEachNodeAfterFilter(node => {
        if (!checked && updateRows.length >= max) return;
        node.data[field] = !checked;
        updateRows.push(node.data.id);
      });
      setData(data => {
        data.filter(d => updateRows.includes(d.id)).forEach(prod => { prod[field] = !checked; });
        if (checked) return data;
        let count = updateRows.length;
        data.filter(d => d[field] && !updateRows.includes(d.id))
          .forEach(prod => {
            if (count < max) count++;
            else prod[field] = false;
          });
        if (updateRows.length + count > max) enqueueSnackbar(`Maximum allowed amount: ${max}`, { variant: "error" });
        return data;
      });
      resParams.api.refreshCells();
      resParams.api.refreshHeader();
    }),
  };
}